import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import useGtm from 'Douleutaras/hooks/gtm';
import { useAppSelector } from 'Douleutaras/redux/hooks';
import { sellerProfilesSelectors } from 'Douleutaras/redux/data/seller/sellerProfilesSlice';
import { sellerProfilesCategoriesSelectors } from 'Douleutaras/redux/data/seller/sellerProfilesCategoriesSlice';

import { PageEventNames } from './settings/gtm';
import './Categories.scss';

const Categories = ({ username, primaryCategory }: { username: string, primaryCategory?: string }) => {
  const { t } = useTranslation();
  const { track } = useGtm();
  const profile = useAppSelector(state => sellerProfilesSelectors.selectByUsername(state, username));
  const [isTrimmed, setIsTrimmed] = useState(false);
  // tslint:disable-next-line:no-null-keyword
  const categoriesListRef = useRef(null);

  const categoriesToShow = 4;
  const categoryIds = profile?.relationships.autodealCategories.data
    .slice(0, categoriesToShow)
    .map(category => category.id) || [];

  const categoriesData = useAppSelector(state =>
    categoryIds
      .map(id => sellerProfilesCategoriesSelectors.selectById(state, id))
      .filter(Boolean)
  );

  const listCategories = primaryCategory
    ? categoriesData.filter(c => c.attributes.title !== primaryCategory)
    : categoriesData;

  useEffect(() => {
    if (profile) {
      const categoriesListWidth = categoriesListRef.current?.scrollWidth || 0;
      setIsTrimmed(categoriesListWidth > 540);
    }
  }, [profile]);

  if (!profile) {
    // tslint:disable-next-line:no-null-keyword
    return null;
  }

  const handleMoreClick = () => {
    // Cleaners get no related-services section, so fall back to the priced catalogue
    const relatedServicesSection = document.getElementById('services')
      || document.getElementById('related-services');
    if (relatedServicesSection) {
      relatedServicesSection.scrollIntoView({ behavior: 'smooth' });
    }
    track(PageEventNames.CATEGORIES_MORE_CLICKED);
  };

  return (
    <div styleName="categories-wrapper">
      <ul ref={categoriesListRef}
          styleName={classNames('categories-list', { trimmed: isTrimmed })}
      >
        {primaryCategory && (
          <li styleName="category-item">
            <h2 styleName="category-primary">{primaryCategory}</h2>
          </li>
        )}
        {listCategories.map(category => (
          <li key={`category_key_${category.id}`} styleName="category-item">
            {category.attributes.title}
          </li>
        ))}
      </ul>
      {isTrimmed && (
        <span onClick={handleMoreClick} styleName="more-services">
          {t('T.PROS-PROFILE.More services')}
        </span>
      )}
    </div>
  );
};

export default Categories;
